import { render, staticRenderFns } from "./AbsenceForm.vue?vue&type=template&id=08f5eede&scoped=true"
import script from "./AbsenceForm.vue?vue&type=script&lang=js"
export * from "./AbsenceForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f5eede",
  null
  
)

export default component.exports